import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Theme from '../../theme';

const headingStyle = level => {
  if (level === 1) {
    return `${Theme.fonts.styles.Header1}`;
  } else if (level === 2) {
    return `${Theme.fonts.styles.Header2}`;
  } else if (level === 3) {
    return `${Theme.fonts.styles.Header3}`;
  } else if (level === 4) {
    return `${Theme.fonts.styles.Header4}`;
  } else if (level === 5) {
    return `${Theme.fonts.styles.Header5}`;
  } else if (level === 6) {
    return `${Theme.fonts.styles.Header6}`;
  } else {
    return `${Theme.fonts.styles.Header1}`;
  }
};

export const H1 = styled.h1`
  ${props => css`
    ${headingStyle(props.overrideStyle || 1)};
  `};
`;

export const H2 = styled.h2`
  ${props => css`
    ${headingStyle(props.overrideStyle || 2)};
  `};
`;

export const H3 = styled.h3`
  ${props => css`
    ${headingStyle(props.overrideStyle || 3)};
  `};
`;

export const H4 = styled.h4`
  ${props => css`
    ${headingStyle(props.overrideStyle || 4)};
  `};
`;

export const H5 = styled.h5`
  ${props => css`
    ${headingStyle(props.overrideStyle || 5)};
  `};
`;

export const H6 = styled.h6`
  ${props => css`
    ${headingStyle(props.overrideStyle || 6)};
  `};
`;

const levels = [H1, H2, H3, H4, H5, H6];

const Heading = props => {
  const { level, overrideStyle, className, children, id } = props;
  const ComponentToRender = levels[level - 1];
  return (
    <ComponentToRender
      id={id}
      overrideStyle={overrideStyle || level}
      className={className}
    >
      {children}
    </ComponentToRender>
  );
};

Heading.defaultProps = {
  className: '',
  level: 1
};

Heading.propTypes = {
  /** Class name */
  className: PropTypes.node,
  /** Children inside component */
  children: PropTypes.node,
  /** Level of header */
  level: PropTypes.number,
  /** Style of header to override level */
  overrideStyle: PropTypes.number
};

Heading.legacyName = 'ux-header';
export default Heading;
